/**
  * @class meleMap_shape
  * @description
  *
  * # Purpose
  * Abstract class for shape
  *
  * # Use
  *
  * # Implementation notes
  *
  */

const melemap_lib = require('./meleMap_lib.js')

export default class meleMap_shape {
  static shape() { return '' }

  constructor(leaflet, props, eventClicked) {
    this._map = leaflet
    this._itemEvent = eventClicked
    this._shape = null // reference to leaflet object representing the shape
    this._guide = null // reference to leaflet object representing the guiding line/object
    this._marker = null // reference to leaflet object representing the marker
    this._handles = [] // reference to leaflet objects representing the edit handles
    if(_.isObjectLike(props)) { this.update(props) }
  }

  get js() {
    return _.extend({}, this._props, {
      shape: this.shape(),
      center: this.center(),
    })
  }

  update(props, silent) {
    // verify props definition
    props = this._props = _.isObjectLike(props) ? _.cloneDeep(props) : {}
    const points = _.toString(props.shape).replace(/^\w(,|$)/, '')
    if(!points) {
      this._points = []
      return
    }
    this._points = melemap_lib.geohash2point(points.splitCorrect(','))
    delete this._center
    if(!silent) this.redraw()
  }

  destroy() {
    this.deleteShape()
    this.deleteMarker()
    if(this._guide) {
      this._map.removeLayer(this._guide)
      this._guide = null
    }
    this._handles.forEach(ref=>this._map.removeLayer(ref))
    this._handles = []
    return null
  }

  // redraw object using current definition
  redraw() {
    this.redrawShape()
    this.redrawGuide()
    this.redrawMarker()
  }

  // redraw object's shape
  redrawShape() {
    this.configureShape()
  }

  configureShape() {
    const el = this._shape ? this._shape._path : null
    if(!el) return
    el.setAttribute('key', _.toString(this._props.key))
    el.setAttribute('marker', _.toString(this._props.marker))
    el.setAttribute('color', _.toString(this._props.color))
    if(this._props.rotate) {
      el.style.setProperty('--gps-rotate', _.toString(this._props.rotate) + 'deg')
    }
    this.selectShape(this._selected)
    el.onclick = (event)=>{ this._itemEvent(event, 'click', this._props.key) }
    el.ondblclick = (event)=>{ this._itemEvent(event, 'dblclick', this._props.key) }
  } // configureShape

  // redraw object's shape
  redrawGuide() {
  }

  deleteShape() {
    if(this._shape) {
      this._map.removeLayer(this._shape)
      this._shape = null
    }
  }

  deleteMarker() {
    if(this._marker) {
      this._map.removeLayer(this._marker)
      this._marker = null
    }
  }

  // redraw object's shape
  calculateCenter() {
    return this._center
  }

  // redraw object's shape
  redrawMarker() {
    const m = this._props
    const actions = m.actions ? JSON.stringify(m.actions).replace(/'/g, "\\'") : ''
    let marker_html = `<mele-marker key="${m.key}" type="${m.marker}" iconright="marker.${m.marker}"`
    if(m.icon) marker_html += ` iconleft="${m.icon||''}"`
    if(m.actions) marker_html += ` actions='${actions}'`
    if(m.heading) marker_html += ` heading="${m.heading}"`
    const attrs = ['color', 'label', 'label2', 'description', 'value']
    attrs.forEach(attr=>{
      const val = _.toString(m[attr])
      if(val!='') marker_html += ` ${attr}="${val}"`
    })
    marker_html += '></mele-marker>'

    // calculate center of the shape for placing the marker
    if(!this._center) this.calculateCenter()
    if(!this._center) {
      this.deleteMarker()
      return
    }

    if(!this._marker) {
      const icon = L.divIcon({ iconSize: [0, 0], iconAnchor: [0, 0] })
      this._marker = L.marker(this._center, { pane: this._props.pane || melemap_lib.DEFAULT_PANE, icon }).addTo(this._map)
    }

    this._marker.setLatLng(this._center) // move where appropriate
    if(this._marker._icon.innerHTML != marker_html) {
      // fill with appropriate content
      this._marker._icon.innerHTML = marker_html
    }
    this.configureMarker()
  }

  configureMarker() {
    const el = this._marker ? this._marker._icon : null
    if(!el) return
    el.setAttribute('key', _.toString(this._props.key))
    el.setAttribute('marker', _.toString(this._props.marker))
    el.setAttribute('color', _.toString(this._props.color))
    if(this._props.rotate) {
      el.style.setProperty('--gps-rotate', _.toString(this._props.rotate) + 'deg')
    }
    this.selectMarker(this._selected)
    el.forAll('mele-marker', el=>{
      el.onclick = (event)=>{ this._itemEvent(event, 'click', this._props.key) }
      el.ondblclick = (event)=>{ this._itemEvent(event, 'dblclick', this._props.key) }
    })
  } // configureMarker

  select(selected) {
    this._selected = selected
    this.selectShape(selected)
    this.selectMarker(selected)
  }

  selectShape(selected) {
    if(this._shape && this._shape._path) {
      this._shape._path.classList.toggle('selected', !!selected)
    }
  }

  selectMarker(selected) {
    if(this._marker && this._marker._icon) {
      this._marker._icon.classList.toggle('selected', !!selected)
      this._marker._icon.forAll('>.mele-marker', el=>el.selected = !!selected)
    }
  }

  // turns on/off edit mode on the shape
  // highlights edit points
  edit(editing) {
  }

  // appends point to the shape; invoked by mouse click in edit mode
  // for DOT will replace previous position
  // for complete CIRCLE, SQUARE or RECTANGLE will start new circle creation
  // for other shapes will append new point to the definition
  addPoint(point) {
  }

  // redraws guide shape; used by mousemove when editing shape
  guide(point) {
  }

  // moves n-th point to new position
  movePoint(idx, point) {
  }

  // returns geohash of shape center
  center() {
    this._center = this._center || this.calculateCenter()
    return melemap_lib.point2geohash(this._center)
  }

  // returns bounds of the shape
  bounds() {
    let bounds = null
    try{
      bounds = this._shape.getBounds()
    }catch(e) {}
    return bounds
  }
} // class meleMap_shape
